import { render, staticRenderFns } from "./CapturePerson.vue?vue&type=template&id=42a13053&scoped=true&"
import script from "./CapturePerson.vue?vue&type=script&lang=js&"
export * from "./CapturePerson.vue?vue&type=script&lang=js&"
import style0 from "./CapturePerson.vue?vue&type=style&index=0&id=42a13053&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a13053",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCard,VCol,VContainer,VDivider,VImg,VRow,VSheet})
